(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["app"] = factory();
	else
		root["app"] = factory();
})(this, function() {
return webpackJsonpapp([2],[
/* 0 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.drawMap = drawMap;
	exports.drawObaneMap = drawObaneMap;
	
	/*
	 * 公開ページ用スクリプト集
	 */
	
	function drawMap(address) {
	  var geocoder = new google.maps.Geocoder();
	  //住所から座標を取得する
	  geocoder.geocode({
	    "address": address,
	    "region": "jp"
	  }, function (results, status) {
	    if (status == google.maps.GeocoderStatus.OK) {
	      google.maps.event.addDomListener(window, "load", function () {
	        var mapTag = document.getElementById("map");
	        // 取得した座標をセット緯度経度をセット
	        var mapLocation = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
	        //マップ表示のオプション
	        var mapOptions = {
	          zoom: 13, //縮尺
	          center: mapLocation, //地図の中心座標
	          //ここをfalseにすると地図上に人みたいなアイコンとか表示される
	          disableDefaultUI: true,
	          mapTypeId: google.maps.MapTypeId.ROADMAP //地図の種類を指定
	        };
	
	        //マップを表示する
	        var map = new google.maps.Map(mapTag, mapOptions);
	
	        //地図上にマーカーを表示させる
	        new google.maps.Marker({
	          position: mapLocation, //マーカーを表示させる座標
	          map: map //マーカーを表示させる地図
	        });
	      });
	    }
	  });
	}
	
	function drawObaneMap() {
	  var geocoder = new google.maps.Geocoder();
	  //住所から座標を取得する
	  geocoder.geocode({
	    "address": "尾花沢市",
	    "region": "jp"
	  }, function (results, status) {
	    if (status == google.maps.GeocoderStatus.OK) {
	      google.maps.event.addDomListener(window, "load", function () {
	        var mapTag = document.getElementById("map");
	        // 取得した座標をセット緯度経度をセット
	        var mapLocation = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
	        //マップ表示のオプション
	        var mapOptions = {
	          zoom: 9, //縮尺
	          center: mapLocation, //地図の中心座標
	          //ここをfalseにすると地図上に人みたいなアイコンとか表示される
	          disableDefaultUI: true,
	          mapTypeId: google.maps.MapTypeId.ROADMAP //地図の種類を指定
	        };
	
	        //マップを表示する
	        var map = new google.maps.Map(mapTag, mapOptions);
	
	        //地図上にマーカーを表示させる
	        new google.maps.Marker({
	          position: mapLocation, //マーカーを表示させる座標
	          map: map //マーカーを表示させる地図
	        });
	      });
	    }
	  });
	}
	
	$(function () {
	  var submenuShown = false;
	  var menuShown = false;
	
	  if ($("li.menu-item").css("display") == "block") {
	    $(".main-menu-pane").hide();
	    menuShown = false;
	  } else {
	    $(".main-menu-pane").show();
	  }
	
	  $("#company-list-menu>a").click(function () {
	    $("#company-list-menu").toggleClass("active");
	    if (submenuShown) {
	      $("#company-list-submenu").hide("slow");
	      submenuShown = false;
	    } else {
	      $("#company-list-submenu").show("slow");
	      submenuShown = true;
	    }
	  });
	
	  $(".my-menu").click(function () {
	    if (menuShown) {
	      $("#company-list-submenu").hide("slow");
	      $(".main-menu-pane").hide("slow");
	      submenuShown = false;
	      menuShown = false;
	    } else {
	      $(".main-menu-pane").show("slow");
	      menuShown = true;
	    }
	  });
	
	  $(window).resize(function () {
	    if ($("li.menu-item").css("display") == "block") {
	      $(".main-menu-pane").hide();
	      menuShown = false;
	    } else {
	      $(".main-menu-pane").show();
	    }
	  });
	});

/***/ })
])
});
;


// WEBPACK FOOTER //
// app.bundle.js